import React from 'react'
import {
  Tag as ChakraTag,
  TagLeftIcon as ChakraTagLeftIcon,
  TagLabel as ChakraTagLabel,
} from '@chakra-ui/react'
import { Text } from '@hub/text'
import {
  As,
  HubStyleObject,
  StandardFontSizes,
  StandardSpacings,
  forwardRef,
} from '@hub/design-system-base'

interface BadgeProps {
  as?: As
  sx?: HubStyleObject
  className?: string
  padding?: StandardSpacings
  fontSize?: StandardFontSizes
  icon?: React.ComponentProps<typeof ChakraTagLeftIcon>['as']
}

export const Badge = forwardRef<BadgeProps, typeof ChakraTag>(
  (
    {
      as,
      className,
      sx,
      children,
      padding = 'spacing-xs',
      fontSize = 'font-sm',
      icon: Icon,
    },
    ref
  ) => (
    <ChakraTag
      ref={ref}
      as={as}
      size="sm"
      padding={padding}
      className={className}
      fontSize={fontSize}
      borderRadius="2px"
      sx={{
        background: 'vibrantTeal',
        color: 'blueCharcoal',
        ...sx,
      }}
    >
      {Icon ? (
        <ChakraTagLeftIcon
          as={forwardRef((props, ref) => (
            <Icon ref={ref} sx={{ marginRight: 'spacing-xs' }} {...props} />
          ))}
          boxSize="14px"
        />
      ) : undefined}
      <ChakraTagLabel>
        <Text
          tone="strong"
          lineHeight="none"
          sx={{ textTransform: 'uppercase' }}
        >
          {children}
        </Text>
      </ChakraTagLabel>
    </ChakraTag>
  )
)
